import React from "react";
import css from "./Data.module.css";

import CustomizeColor from "./CustomizeColor/CustomizeColor";
import SessionInfo from "./SessionInfo/SessionInfo";

const Data = ({ sessionId, layoutFns }) => {
  return (
    <div style={styleRelativeContainer}>
      <div className={css.config}>
        <CustomizeColor sessionId={sessionId} layoutFns={layoutFns} />
        <SessionInfo sessionId={sessionId} layoutFns={layoutFns} />
        <div className={css.metaUtilities}>
          <button className={css.screenshot} onClick={layoutFns.savePNG}>
            Save PNG
          </button>
          <button className={css.downloadJson} onClick={layoutFns.downloadJSON}>
            Save JSON
          </button>
        </div>
      </div>
    </div>
  );
};

export default Data;

const styleRelativeContainer = {
  position: "relative",
  width: "100%",
  height: "100%",
};
